export const placeSkeletonStyles = {
  wrapper: {
    display: { laptop: "flex" },
    alignItems: { laptop: "center" },
    justifyContent: { laptop: "center" },
    mx: {
      mobile: "1.5rem",
      tablet: "2.438rem",
      laptop: "unset",
    },
    mb: {
      tablet: "4.188rem",
      laptop: "10rem",
    },
    mt: {
      mobile: "5rem",
    },
  },
  container: {
    mb: {
      mobile: "5rem",
      laptop: "1.5rem",
    },
    alignItems: {
      tablet: "center",
      justifyContent: "center",
    },
    maxWidth: {
      laptop: "18rem",
      desktop: "21.875rem",
    },
    mx: {
      laptop: "3.125rem",
    },
  },
  image: {
    width: "12.625rem",
    height: "12.625rem",
    margin: {
      mobile: "0 auto 3rem",
      tablet: "0 1.875rem 3rem",
      laptop: "3rem auto 3rem",
    },
  },
  textContainer: {
    alignItems: "center",
    justifyContent: {
      mobile: "center",
      tablet: "left",
    },
    width: {
      mobile: "85vw",
      tablet: "55vw",
      laptop: "20vw",
    },
    mb: {
      laptop: "5rem",
    },
  },
  text: {
    width: {
      mobile: "50vw",
      tablet: "20vw",
      laptop: "12vw",
    },
    maxWidth: "6.25rem",
    my: "2rem",
  },
  button: {
    width: "9.5rem",
    height: "3.5rem",
  },
};
